// components/common/product.js
'use client';

import { Flex, Typography } from 'antd'
import Image from 'next/image'
import { isNull, encryptData } from '@/lib/utils';
import { useRouter } from 'nextjs-toploader/app';
import { memo, useCallback, useMemo } from 'react';
import './product.scss'

const { Paragraph } = Typography;

const ProductItem = memo(({ item, btnSend, isOpen }) => {
    if (isNull(item)) {
        return null;
    }

    const router = useRouter();

    const handleClickProduct = useCallback((item) => {
        if (isOpen) {
            window.open(`/productdetail/${item.id}`, '_blank');
            return;
        }
        router.push(`/productdetail/${item.id}`)
    }, [isOpen, router]);

    const btnSendInquiry = useCallback((e) => {
        e.stopPropagation();
        window.open(`/sendInquiry?pid=${item.id}`)
    }, [item.id]);

    const handleToFindProduct = useCallback((e) => {
        e.stopPropagation();
        let url = item.picUrl || item.pic;
        window.open(`/search?type=identifying&searchKey=${encryptData(url)}`)
    }, [item.pic, item.picUrl]);

    // 预处理图片 URL
    const imageUrl = useMemo(() => {
        const basePic = item.picUrl || item.pic;
        return basePic ? `${basePic}?x-oss-process=image/resize,w_300,h_300,limit_0` : '';
    }, [item.pic, item.picUrl]);

    return (
        <div className='li_product' onClick={() => handleClickProduct(item)}>
            <div className='li_product_img_item'>
                <Image
                    src={imageUrl}
                    alt={item.name}
                    fill
                    className='li_product_img'
                    loading="lazy"
                    placeholder="blur"
                    blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAA1JREFUGFdj+PLly38ACZgD3EOjaxgAAAAASUVORK5CYII="

                    sizes="(max-width: 768px) 50vw, (max-width: 1200px) 25vw, 20vw"
                />
                <div className='find_img' onClick={handleToFindProduct}>Find similar items</div>
            </div>
            <Flex flex={1} vertical="vertical" justify='space-between'>
                <Paragraph ellipsis={{ rows: 2 }} className='li_product_name'>{item.name}</Paragraph>
                <div>
                    <p className='li_product_price'>{item.priceUnit}{item.price}</p>
                    <p className='li_product_desc'>{item.minOrderQuantity} {item.prodUnit} (MOQ)</p>
                </div>
                {btnSend && (
                    <Flex align='center' justify='end'>
                        <Flex
                            align='center'
                            justify='center'
                            className='search_btn_send_inquiry'
                            onClick={btnSendInquiry}
                        >
                            Send Inquiry
                        </Flex>
                    </Flex>
                )}
            </Flex>
        </div>
    );
});

ProductItem.displayName = 'ProductItem';

export default ProductItem;